import type { FC } from "react";

import createComponentPreset from "../../../../../fabrics/createComponentPreset";
import { Counter } from "../../../../Counter";
import { createDisplayNameForButtonCircleElement } from "../../utils/getDisplayName";
import { createTestIdForButtonCircleElement } from "../../utils/getTestId";

import type { CounterProps } from "../../../../Counter";

export type ButtonCircleCounterProps = Omit<CounterProps, "size">;

const name = "Counter";
const displayName = createDisplayNameForButtonCircleElement(name);
const testId = createTestIdForButtonCircleElement(name);

const ButtonCircleCounter = createComponentPreset<FC<ButtonCircleCounterProps>>(
    displayName,
    Counter,
    {
        view: "primary",
        stroke: true,
        "data-tsid": testId,
    },
);
export default ButtonCircleCounter;
